import { DOMAIN_CONFIG } from '../config/domain';

export const updatePageMeta = (page: {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}) => {
  // Update page title
  if (page.title) {
    document.title = `${page.title} | ${DOMAIN_CONFIG.seo.title}`;
  }

  // Update meta description
  const description = page.description || DOMAIN_CONFIG.seo.description;
  updateMetaTag('description', description);

  // Update meta keywords
  const keywords = page.keywords || DOMAIN_CONFIG.seo.keywords;
  updateMetaTag('keywords', keywords);

  // Update Open Graph tags
  updateMetaTag('og:title', page.title || DOMAIN_CONFIG.seo.title);
  updateMetaTag('og:description', description);
  updateMetaTag('og:image', page.image || DOMAIN_CONFIG.seo.image);
  updateMetaTag('og:url', page.url || `https://${DOMAIN_CONFIG.domain}`);
  updateMetaTag('og:type', 'website');

  // Update Twitter Card tags
  updateMetaTag('twitter:card', 'summary_large_image');
  updateMetaTag('twitter:title', page.title || DOMAIN_CONFIG.seo.title);
  updateMetaTag('twitter:description', description);
  updateMetaTag('twitter:image', page.image || DOMAIN_CONFIG.seo.image);
};

const updateMetaTag = (name: string, content: string) => {
  let element = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`) as HTMLMetaElement;
  
  if (!element) {
    element = document.createElement('meta');
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      element.setAttribute('property', name);
    } else {
      element.setAttribute('name', name);
    }
    document.head.appendChild(element);
  }
  
  element.setAttribute('content', content);
};